import customPanel from './main.vue';

export default customPanel;
